import { render, staticRenderFns } from "./RecentProject.vue?vue&type=template&id=13945028&scoped=true&"
import script from "./RecentProject.vue?vue&type=script&lang=js&"
export * from "./RecentProject.vue?vue&type=script&lang=js&"
import style0 from "./RecentProject.vue?vue&type=style&index=0&id=13945028&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13945028",
  null
  
)

export default component.exports